/* ==========================================================================
   Keep the Shopify Inbox chat launcher ("Χρειάζεστε βοήθεια;") out of the way.
   Owner rule (2026-10-07): no information may stay hidden behind the launcher.

   2026-09-27 (product page): hidden while the size picker / add-to-cart /
   try-on buttons are on screen. Phones only until 2026-10-07, every width since.
   2026-10-05 (all pages, all widths; loaded from layout/theme.liquid): also
   hidden while the footer is on screen, because it covered the shop info.
   2026-10-07: also hidden while the page is being scrolled; it comes back
   1.5 s after scrolling stops.
   2026-10-16: also hidden while the cookie banner (#shopify-pc__banner) is open:
   on a first visit the banner fills the lower half of a phone and the launcher
   sat on top of its buttons.
   Open panels (filters, cart, quick add, menus, search, galleries) are
   handled in CSS (assets/elliz-fixes.css) through the classes they already set.

   <html> gets `elliz-chat-away` / `elliz-chat-scrolling`; the CSS fades the
   launcher out. An open chat window (shopify-chat[open]) is never hidden by
   these two classes, so a customer who is chatting can keep scrolling.
   ========================================================================== */
(function () {
  if (window.__ellizChatAutohide) return;
  window.__ellizChatAutohide = true;
  var root = document.documentElement;

  /* Scrolling: one class add at the start and one remove at the end, no layout reads. */
  var scrollTimer = 0;
  var scrolling = false;
  window.addEventListener('scroll', function () {
    if (!scrolling) {
      scrolling = true;
      root.classList.add('elliz-chat-scrolling');
    }
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      scrolling = false;
      root.classList.remove('elliz-chat-scrolling');
    }, 1500);
  }, { passive: true });

  if (!('IntersectionObserver' in window)) return;

  /* While any of these is on screen the launcher stays hidden (every page, every width). */
  var SELECTORS = [
    'footer.elliz-footer',
    'variant-selects[id^="variant-selects-"]',
    '#product-container',
    '.genlook-try-on-button',
    '#shopify-pc__banner'
  ];
  var onScreen = new Set();
  var io = null;

  function apply() {
    root.classList.toggle('elliz-chat-away', onScreen.size > 0);
  }

  function observe() {
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) onScreen.add(e.target);
          else onScreen.delete(e.target);
        });
        apply();
      });
    }
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.__ellizChatObserved) return;
        el.__ellizChatObserved = true;
        io.observe(el);
      });
    });
  }

  function init() {
    observe();
    /* The GenLook buttons are injected by their app blocks after load. */
    setTimeout(observe, 1500);
    setTimeout(observe, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
